module.exports = __webpack_public_path__ + "img/new_learning_focus.9a263ead.svg";